import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { Link, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useListVals } from 'react-firebase-hooks/database'
import routes from '../routes'
import { NotificationDb } from '../firebaseConfig'
import Amplitude from '../utils/amplitudeHelper'
import { showGlobalModal } from 'src/ducks/layout'
import { GlobalModalTypes } from 'src/components/GlobalModals/modalTypes'

import homeIcon from 'src/images/ntc/lobby/mobile-nav-lobby-active.svg'
import notificationIcon from 'src/images/ntc/lobby/mobile-nav-notifications.svg'
import helpDeskIcon from 'src/images/ntc/lobby/mobile-nav-help-desk.svg'
import logoutIcon from 'src/images/ntc/lobby/mobile-nav-log-out.svg'

const MobileNav = React.memo(() => {
  const location = useLocation()
  const dispatch = useDispatch()
  const currentUser = useSelector((state) => state.auth.currentUser)
  const globalModal = useSelector((state) => state.layout.globalModal)
  const [values, loading] = useListVals(NotificationDb)
  const [unread, setUnread] = useState(false)

  useEffect(() => {
    if (values && !loading) {
      if (values.length < localStorage.getItem('IA_notifications')) {
        localStorage.setItem('IA_notifications', 0)
      }
      setUnread(values.length > localStorage.getItem('IA_notifications'))
    }
  }, [values, loading])

  const handleNotification = () => {
    Amplitude.clickNotification()
    dispatch(showGlobalModal(GlobalModalTypes.Notifications))
    setUnread(false)
  }

  // The attendance reminder modal performs the actual logout once acknowledged.
  const handleLogout = () => {
    dispatch(showGlobalModal(GlobalModalTypes.LogoutNotice))
  }

  const showHelpDesk = () => {
    const cpt = window.chaport
    if (!cpt) return

    cpt.on('ready', function () {
      cpt.setVisitorData({
        name: currentUser.fullName,
        email: currentUser.email,
      })
      cpt.open()
    })
    cpt.on('collapsed', function () {
      cpt.close()
    })
    Amplitude.clickHelpDesk()
  }

  return (
    <Page>
      <nav className="navbar" aria-label="Main navigation">
        <Link className={`nav-item ${location.pathname === routes.lobby ? 'active' : ''}`} to={routes.lobby}>
          <span className="nav-icon-frame" aria-hidden="true">
            <img className="nav-icon nav-icon-home" src={homeIcon} alt="" />
          </span>
          <span>Lobby</span>
        </Link>
        <button
          className={`nav-item ${globalModal === GlobalModalTypes.Notifications ? 'active' : ''} ${unread ? 'with-shake' : ''}`}
          type="button"
          onClick={handleNotification}
        >
          <span className="nav-icon-frame" aria-hidden="true">
            <img className="nav-icon nav-icon-notification" src={notificationIcon} alt="" />
          </span>
          <span className="notification-indicator" hidden={!unread} />
          <span>Notifications</span>
        </button>
        <button className="nav-item" type="button" onClick={showHelpDesk}>
          <span className="nav-icon-frame" aria-hidden="true">
            <img className="nav-icon nav-icon-help" src={helpDeskIcon} alt="" />
          </span>
          <span>Help Desk</span>
        </button>
        <button className="nav-item" type="button" onClick={handleLogout}>
          <span className="nav-icon-frame" aria-hidden="true">
            <img className="nav-icon nav-icon-logout" src={logoutIcon} alt="" />
          </span>
          <span>Log Out</span>
        </button>
      </nav>
    </Page>
  )
})

const Page = styled.div`
  position: fixed;
  z-index: 60;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 77px;
  display: block;
  background: var(--Gold-Gradient-01);
  box-shadow: 0 -5px 3.65px rgba(0, 0, 0, 0.11);
  font-family: 'Din', 'DIN', sans-serif;

  .navbar {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    gap: 20px;
    padding: 10px 10px 19px;
  }

  .nav-item {
    position: relative;
    flex: 1 1 0;
    min-width: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    padding: 0;
    border: 0;
    background: transparent;
    color: #000;
    font: inherit;
    text-decoration: none;
    cursor: pointer;

    > span:not(.notification-indicator):not(.nav-icon-frame) {
      color: #000;
      font-size: 12px;
      font-weight: 400;
      line-height: 1;
      white-space: nowrap;
    }
  }

  .nav-icon-frame {
    width: 30px;
    height: 30px;
    flex: 0 0 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }

  .nav-icon {
    display: block;
    max-width: none;
  }

  .nav-icon-home {
    width: 26.25px;
    height: 24.536px;
    filter: brightness(0);
  }

  .nav-icon-notification {
    width: 22.278px;
    height: 24px;
  }

  .nav-icon-help {
    width: 24px;
    height: 24px;
  }

  .nav-icon-logout {
    width: 30px;
    height: 30px;
  }

  .nav-item.active .nav-icon:not(.nav-icon-home) {
    filter: brightness(0) invert(1);
  }

  .nav-item.active .nav-icon-home {
    filter: none;
  }

  .nav-item:focus-visible {
    outline: 2px solid #262c65;
    outline-offset: 2px;
  }

  .notification-indicator {
    position: absolute;
    top: -2px;
    right: 22%;
    width: 8px;
    height: 8px;
    box-sizing: border-box;
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 50%;
    background: #e00000;
  }
`

export default MobileNav
